export default __webpack_public_path__ + "static/media/slider.213dfdc1.svg";